import React, { useState } from 'react';
import './TicTacToe.scss';
import calculateWinner from '../../../helpers/calculateWinner';
import useTimeMachine from '../../../hooks/useTimeMachine';
import { IStateTicTac } from '../../../interfaces/IStateTicTac';
import { ITimeMachine } from '../../../interfaces/ITimeMachine';
import { TSquare } from '../../../types/TSquare';
import Square from '../../square';

const initialValue: IStateTicTac = {
  squares: Array<null | string>(9).fill(null),
  xIsNext: true,
};

const TicTactToe = () => {
  const {
    state,
    updateValues,
    previous,
    current,
    next,
    resume,
    reset,
    replay,
    isEditable,
  }: ITimeMachine<IStateTicTac> = useTimeMachine<IStateTicTac>(initialValue);

  const [isReplaying, setIsReplaying] = useState(false);

  const handleClick = (i: number) => {
    if (isEditable) {
      const squares2: Array<null | string> = state[current].squares.slice();
      if (calculateWinner(squares2) || squares2[i]) {
        return;
      }
      squares2[i] = state[current].xIsNext ? '×' : 'o';

      const copy = { squares: squares2, xIsNext: !state[0].xIsNext };
      updateValues(copy);
    }
  };

  const renderSquare = (i: number) => (
    <Square
      key={i}
      value={state[current].squares[i]}
      onClick={() => handleClick(i)}
      customClass={state[current].squares[i] === 'o' ? 'square square-aqua' : 'square square-blue'}
    />
  );

  const resetGameBoard = () => {
    reset();
  };

  const replayGame = async () => {
    setIsReplaying(true);
    await replay();
    setIsReplaying(false);
  };

  const winner = calculateWinner(state[current].squares);
  let status;
  let window;

  if (winner) {
    status = 'Winner:';
    window = winner;
  } else {
    status = (state.length === 10 && current === 0) ? 'Draw' : 'Next to move:';
    window = state[current].xIsNext ? '×' : 'o';
  }

  return (
    <div className="game">
      <div className="game-board">
        <h1 className="title-board">Tic Tac Toe</h1>
        <div>
          <div className="board-container">
            <div className="board">
              {state[current].squares.map((e:TSquare, index: number) => (
                renderSquare(index)
              ))}
            </div>
            <div className={isReplaying ? 'buttons not-selectable' : 'buttons'}>
              <button
                type="button"
                onClick={previous}
                className={(current === (state.length - 1)) ? 'option-button disabled' : 'option-button'}
              >
                Previous
              </button>
              {
            winner && (
            <button
              type="button"
              onClick={replayGame}
              className="option-button"
            >
              Replay
            </button>
            )
          }
              {
            !winner && (
              <button
                type="button"
                onClick={resume}
                className={(current === 0) ? 'disabled option-button' : 'option-button'}
              >
                {isReplaying ? 'Replaying ...' : 'Resume'}
              </button>
            )
          }
              <button
                type="button"
                onClick={next}
                className={(current === 0) ? 'disabled option-button' : 'option-button'}
              >
                Next
              </button>
              <button
                type="button"
                onClick={resetGameBoard}
                className="option-button"
              >
                Reset
              </button>
              <div className="status">{status}</div>
              <div className="winner">
                <span>{window}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TicTactToe;
